import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

interface SettingsMappingDefinitionsDefinitionContentSignature {
  Args: {
    description: unknown;
    points: unknown;
  };
}

const SettingsMappingDefinitionsDefinitionContent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="definition">
    <div class="definition__text">{{t @description}}</div>
    <ul class="definition__list">
      {{#each @points as |point|}}
        <li class="definition__list__item">
          {{t point}}
        </li>
      {{/each}}
    </ul>
  </div>
</template> satisfies TOC<SettingsMappingDefinitionsDefinitionContentSignature>;

export default SettingsMappingDefinitionsDefinitionContent;
